import { UseFormReturn, FieldError, FieldErrorsImpl, Merge } from "react-hook-form";
import FormInputProps, { ValidationProps } from "./Types";

type FormReturnType = {
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
  onChange?: (value: any) => void;
  value: any;
} | null;

export type UseFormProps = {
  value?: Exclude<any, undefined>;
  onChange?: (val: any) => void;
  formInstance?: UseFormReturn<any, any>;
  name?: string;
  validation?: ValidationProps;
}

const getValue = (...vals: any[]) => {
  for (let i = 0; i < vals.length; i++) {
    const element = vals[i];
    if (element !== undefined) return element;
  }

  return "";
}

export const useFormInputs = (formProps: UseFormProps): FormReturnType => {
  if (!formProps.formInstance || !formProps.name) {
    return {
      onChange: formProps.onChange,
      value: getValue(formProps.value),
    }
  }
  
  const error = formProps.formInstance?.formState?.errors?.[formProps.name || ""];
  
  formProps.formInstance.register(formProps.name, {...formProps.validation});

  const onChange = (val: any) => {
    if (formProps.onChange) {
      return formProps.onChange(val);
    }

    if (val !== undefined) {
      return formProps.formInstance?.setValue(formProps.name!, val);
    }

    return formProps.formInstance?.setValue(formProps.name!, null);
  }

  const ret: FormReturnType = {
    error,
    onChange,
    value: getValue(formProps.value, formProps.formInstance.watch(formProps.name)),
  }

  return ret;
}

export const destructProps = <T extends FormInputProps<any>>(props: T) => {
  const { value, onChange, formInstance, name, validation, ...baseProps } = props;

  return {
    formProps: {
      value,
      onChange,
      formInstance,
      name,
      validation
    },
    baseProps,
  }
}